import {DatePipe} from '@angular/common';
import {Pipe, PipeTransform} from '@angular/core';
import {DateFormatPipe as MomentDateFormatPipe} from 'ngx-moment';
import {isValidDate2} from 'src/app/utils/date';

@Pipe({
    name: 'customDate'
})
export class CustomDatePipe extends DatePipe implements PipeTransform {

    transform(value: any, args?: any): any {
        const isDate = isValidDate2(value);
        if (isDate) {
            if (window.localStorage.getItem('TUNEPS_LANG') == 'ar') {
                return new MomentDateFormatPipe().transform(value, 'YYYY/MM/DD HH:mm');

            } else if (window.localStorage.getItem('TUNEPS_LANG') != 'fr') {
                return new MomentDateFormatPipe().transform(value, 'DD/MM/YYYY HH:mm ');
            }


        } else {
            return value;
        }

    }
}
